import React, { useEffect, useRef } from 'react';
// import './OverlayContainer.css'
import About from '../../overlayContent/About'
import Work from '../../overlayContent/Work'
import Contact from '../../overlayContent/Contact'
import OverlayContainerNav from './OverlayContainerNav'

const OverlayContainer = ({ lang, isVisible, currentContent, setContent, setWorkInlineContainerVisible }) => {
    const overlayContainerRef = useRef(null);

    useEffect(() => {
        const overlayContainer = overlayContainerRef.current;
        // const _currentContent = currentContent;
        if (overlayContainerRef.current) {
            if (isVisible) {
                // 1. transition을 제거하고 100dvh로 강제 이동
                overlayContainer.style.transition = 'none';
                overlayContainer.style.transform = 'translateY(100dvh)';

                setContent('');
                // 2. 다음 프레임에서 transition을 다시 적용하여 0vh로 이동
                setTimeout(() => {
                    setContent(currentContent);
                    overlayContainer.style.transition = '0.5s cubic-bezier(0.165, 0.84, 0.44, 1)';
                    overlayContainer.style.transform = 'translateY(0vh)';
                    overlayContainer.style.opacity = 1;
                    document.body.scrollTo({ top: 0, behavior: "smooth" })
                }, 10);
            }
            else {
                overlayContainer.style.transition = '0.3s ease-out';
                overlayContainer.style.transform = 'translateY(100dvh)';
                overlayContainer.style.opacity = 0;
            }
        }
    }, [isVisible]); // isVisible이 변경될 때 실행

    useEffect(() => {
        renderContent();
    }, [lang])

    const overlayContainerStyle = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        // marginTop: '100px',
        height: '100dvh',
        zIndex: '99',
        opacity: isVisible ? 1 : 0,
        transition: '0.3s ease-out',
        transform: 'translateY(100dvh)',
        // overflowY: 'scroll'
    }

    const renderContent = () => {
        switch (currentContent) {
            case 'About':
                return <About
                    lang={lang} />
            case 'Work':
                return <Work
                    lang={lang}
                    setWorkInlineContainerVisible={setWorkInlineContainerVisible} />
            case 'Contact':
                return <Contact
                    lang={lang} />
            default:
                return null
        }
    }

    return (
        <>
            <div
                ref={overlayContainerRef}
                className={`overlay-container`}
                style={overlayContainerStyle}>
                {/* <About />
                <Work />
                <Contact /> */}
                {renderContent()}
            </div>
        </>
    )
}
export default OverlayContainer